import { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { StandardButton } from '../../../../../component/common/StandardUI';
import chatBubbleIcon from '../../../../../assets/svg/icons/Chat-Bubble-Text-Oval--Streamline-Flex.svg';

const COLLAPSED_COUNT = 2;

const CommentsPanel = ({ comments, onAddComment, submitting }) => {
  const [text, setText] = useState('');
  const [showAll, setShowAll] = useState(false);

  const handleSubmit = async () => {
    if (!text.trim()) return;
    await onAddComment(text.trim());
    setText('');
  };

  const visibleComments = showAll ? comments : comments.slice(0, COLLAPSED_COUNT);

  return (
    <div>
      <div className="flex items-start justify-between gap-3">
        <h3 className="text-base font-medium text-gray-700 dark:text-gray-200">Comments</h3>
        {comments.length > COLLAPSED_COUNT && (
          <button
            type="button"
            onClick={() => setShowAll((prev) => !prev)}
            className="text-sm font-medium text-shoorah-primary hover:underline shrink-0"
          >
            {showAll ? 'Show less' : 'View all comments'}
          </button>
        )}
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-400 mt-1 mb-4">
        Here are comment/notes left by other member of your shoorah admin team.
      </p>

      <div className="space-y-3 mb-4">
        {comments.length === 0 && (
          <p className="text-sm text-gray-400 dark:text-gray-500">No comments yet.</p>
        )}
        {visibleComments.map((comment, index) => (
          <div
            key={comment._id || index}
            className="rounded-input border border-shoorah-borderGray dark:border-shoorah-darkBorder bg-shoorah-normanGray dark:bg-shoorah-darkBgColor p-4"
          >
            <div className="flex items-start gap-3">
              <img src={chatBubbleIcon} alt="" className="w-6 h-6 shrink-0 dark:invert" />
              <div className="min-w-0">
                <p className="text-sm font-medium text-gray-700 dark:text-gray-200">
                  Message from{' '}
                  {comment.commenter?.name ||
                    comment.commentedBy?.name ||
                    comment.userName ||
                    'Team member'}
                </p>
                {comment.createdAt && (
                  <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                    Added on: {moment(comment.createdAt).format('MMMM Do, hh:mma')}
                  </p>
                )}
              </div>
            </div>
            <p className="text-sm text-gray-600 dark:text-gray-300 mt-3">
              <span className="font-medium text-gray-700 dark:text-gray-200">Message:</span>{' '}
              {comment.text}
            </p>
          </div>
        ))}
      </div>

      <div className="rounded-input border-[1.5px] border-shoorah-borderGray dark:border-shoorah-darkBorder p-4">
        <div className="flex items-center gap-3">
          <img src={chatBubbleIcon} alt="" className="w-6 h-6 shrink-0 dark:invert" />
          <p className="text-sm font-medium text-gray-700 dark:text-gray-200">Add comment</p>
        </div>
        <textarea
          id="people-plan-comment"
          aria-label="Type your message"
          placeholder="Type your message:"
          value={text}
          onChange={(e) => setText(e.target.value)}
          rows={2}
          className="block w-full mt-3 bg-transparent border-0 p-0 text-[14px] text-gray-700 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-0 resize-none"
        />
        <div className="flex justify-end">
          <StandardButton
            text="Save"
            onClick={handleSubmit}
            disabled={submitting || !text.trim()}
          />
        </div>
      </div>
    </div>
  );
};

CommentsPanel.propTypes = {
  comments: PropTypes.array.isRequired,
  onAddComment: PropTypes.func.isRequired,
  submitting: PropTypes.bool
};

export default CommentsPanel;
